import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M54.525 39H9c-.85 0-1.563-.288-2.138-.862C6.287 37.563 6 36.85 6 36c0-.85.287-1.563.862-2.138S8.15 33 9 33h45.525L42.9 21.3c-.55-.55-.837-1.238-.862-2.063-.025-.824.262-1.537.862-2.137.55-.55 1.25-.825 2.1-.825.85 0 1.55.275 2.1.825l16.8 16.8c.3.3.512.625.637.975s.188.725.188 1.125-.063.775-.188 1.125-.337.675-.637.975L47.1 54.9c-.55.55-1.238.825-2.063.825A3.057 3.057 0 0 1 42.9 54.9c-.6-.6-.9-1.313-.9-2.137 0-.825.3-1.538.9-2.138L54.525 39Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-right"}) } }